export const LOADING_EDUCATION_LEVEL = "LOADING_EDUCATION_LEVEL"
export const SAVE_LOADING_EDUCATION_LEVEL = "SAVE_LOADING_EDUCATION_LEVEL"
export const GET_EDUCATION_LEVEL = "GET_EDUCATION_LEVEL"
export const FORM_FAIL = "FORM_FAIL"
export const EDUCATION_LEVEL_FAIL = "EDUCATION_LEVEL_FAIL"
export const LOADING_EDUCATION_LEVEL_BY_ID = "LOADING_EDUCATION_LEVEL_BY_ID"
export const GET_EDUCATION_LEVEL_BY_ID = "GET_EDUCATION_LEVEL_BY_ID"